/**
 * Класс по работе с формой обратной связи
 */
import {Helpers} from "../helpers/helpers";
import {ERROR_STATUS} from "../constans";
import IMask from "imask";
import $ from "jquery";
import PopupManager from "../managers/PopupManager";

export default class FeedbackForm {
    private ACTIVE_CLASS = 'active';
    private ERROR_CLASS = 'has-error';
    private LOADING_CLASS = 'loading';
    private TYPE_CAPTCHA_POPUP = 'captcha-popup';
    private TYPE_SUCCESS_POPUP = 'success-form';

    private currentValue: number = 0;
    private resizeTimeout: any|null = null;

    private readonly $holder: JQuery;
    private readonly $forms: JQuery;
    private readonly $formWrapper: JQuery;
    private readonly $checkboxAddress: JQuery;
    private popupManager: PopupManager;

    private selectors = {
        itemForm: '.js-feedback-form-item',
        btnAddField: '.js-add-field',
        brnChangeStep: '.js-change-step',
        btnToggleWrapper: '.js-toggle',
        btnToggle: '.js-toggle-item',
        formContent: '.js-feedback-form-content',
        formHolder: '.js-feedback-form-holder',
        formWrapper: '.js-feedback-form-wrapper',
        formStep: '.js-form-step',
        questionWrapper: '.js-wrapper-question',
        questionField: '.js-question-fields',
        question: '.js-question',
        simpleFormHolder: '.js-simple-form-holder',
        checkboxAddress: '.js-checkbox-address',
        fieldCheckbox: '.js-field-checkbox',
        feedbackForm: '.js-feedback-form',
        fieldError: '.js-simple-form-error',
        fieldPhone: '.js-simple-telephone',
        captchaInput: '.js-captcha-input',
        captchaImage: '.js-captcha-image',
        refreshCaptchaBtn: '.js-refresh-captcha',
        confirmPopupBtn: '.js-confirm-popup',
    }

    constructor($holder: JQuery, popupManager: PopupManager) {
        this.$holder = $holder;
        this.$forms = this.$holder.find(this.selectors.itemForm);
        this.$formWrapper = this.$holder.find(this.selectors.formWrapper);
        this.$checkboxAddress = this.$holder.find(this.selectors.checkboxAddress);
        this.popupManager = popupManager;


        this.getRequestData = this.getRequestData.bind(this);
        this.randomCharacter = this.randomCharacter.bind(this);
        this.refreshCaptcha = this.refreshCaptcha.bind(this);
        this.cleanCaptchaField = this.cleanCaptchaField.bind(this);
        this.changeFeedbackForm = this.changeFeedbackForm.bind(this);

        this.initEvents();
    }

    /**
     * Инициализация событий
     */
    private initEvents(): void {
        this.$holder.on('click', this.selectors.btnToggle, this.changeFeedbackForm);

        //клик на кнопку изменения шага
        this.$holder.on('click', this.selectors.brnChangeStep, (evt) => {
            const $activeStep = $(evt.target).closest(this.selectors.formStep)
            const activeStepNumber = $activeStep.data('number-step');
            const event = $(evt.target).closest(this.selectors.brnChangeStep).data('event');

            this.changeStepForm(activeStepNumber, event);
        });

        //добавление полей в вопросе
        this.$holder.on('click', this.selectors.btnAddField, (event) => {
            this.addField(event);
        });

        // Инициализируем инпут, значение которого меняется от состояния чекбокса
        const $checkboxFields = $(this.selectors.fieldCheckbox);
        $checkboxFields.each((index, field) => {
            Helpers.changeInputValueByCheckbox($(field));
        });

        //дублирование адреса при выбранном чекбоксе
        this.$checkboxAddress.on('change', (event) => {
            const $mainAddress = this.$holder.find('.js-main-address');
            const $duplicateAddress = $(event.target).closest(this.selectors.simpleFormHolder);

            if ($(event.target).is(':checked')) {
                $duplicateAddress.find('input')
                    .val($mainAddress.find('input').val());
                $duplicateAddress.find(`input[type="text"]`)
                    .prop('readOnly', true);
                $mainAddress.on('input', () => {
                    $duplicateAddress.find('input')
                        .val($mainAddress.find('input').val());
                });
            } else {
                $duplicateAddress.find(`input[type="text"]`)
                    .prop('readOnly', false);
                $mainAddress.off('input');
            }
        });

        this.$forms.on('change', 'input', (evt) => {
            this.clearError($(evt.currentTarget));
        });

        this.$forms.on('change', 'textarea', (evt) => {
            this.clearError($(evt.currentTarget));
        });

        this.$forms.find(this.selectors.fieldPhone).each((_, item) => {
            const maskOptions = {
                mask: '+{7}(000)0000000',
                lazy: true,
            };

            const mask = IMask(item, maskOptions);

            $(item).on('focus', () => {
                mask.updateValue();
                mask.updateOptions({
                    lazy: false,
                });
            });

            $(item).on('blur', () => {
                mask.updateOptions({ lazy: true });
            });
        });

        // Отправка формы
        this.$forms.on('submit', (event) => {
            event.preventDefault();
            this.preSubmitForm();
        });

        $(window).on('resize', () => {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = window.setTimeout(() => {
                this.toggleHeightWrapper();
            }, 100);
        });

        this.$forms.on('click', this.selectors.refreshCaptchaBtn, (evt) => {
            this.refreshCaptcha();
        });

        this.$forms.on('click', this.selectors.confirmPopupBtn, (evt) => {
            this.popupManager.closeAllPopup();
            this.submit();
        });
    }

    /**
     * Смена формы
     * @private
     */
    private changeFeedbackForm(event: Event): void {
        const $target = $(event.currentTarget);
        this.currentValue = $target.index();

        this.toggleHeightWrapper();

        this.$forms.removeClass(this.ACTIVE_CLASS);
        this.$forms.eq(this.currentValue).addClass(this.ACTIVE_CLASS);
    }

    /**
     * Меняем высоту обертки под контен
     * @private
     */
    private toggleHeightWrapper(): void
    {
        const MARGIN_TOGGLE_BUTTON = 20;
        const $formContent = this.$holder.find(this.selectors.formContent);

        //внутренние отступы формы
        const topPadding: number = +($formContent.css('padding').split(' ')[0].slice(0, -2));

        //высота контента формы
        const formHeight: number = this.$forms.eq(this.currentValue).height();

        //высота кнопок переключателя
        const btnToggleHeight = this.$holder.find(this.selectors.btnToggleWrapper).height();

        const allHeight = topPadding * 2 + formHeight + btnToggleHeight + MARGIN_TOGGLE_BUTTON;

        this.$formWrapper.height(allHeight);
    }

    /**
     * Изменение шага формы
     * @param activeStep
     * @param event
     * @private
     */
    private changeStepForm = (activeStep: number, event: string): void => {
        const newStep = (event === 'next') ?  activeStep + 1 : activeStep - 1;
        if ( event === 'next' ) {
            this.validateDistributorForm(activeStep, newStep);
        } else {
            this.toggleClassStep(activeStep, newStep);
        }

        $('html, body').animate({
            scrollTop: this.$formWrapper.offset().top
        });
    };


    /**
     * Изменение видимости шагов формы
     * @param activeStep
     * @param newStep
     * @private
     */
    private toggleClassStep = (activeStep: number, newStep: number) => {
        $(`.js-form-step[data-number-step="${activeStep}"]`).removeClass('active');
        $(`.js-form-step[data-number-step="${newStep}"]`).addClass('active');
        this.toggleHeightWrapper();
    }

    /**
     * Добавляем поля
     * @private
     */
    private addField(event): void {

        const $questionsWrapper = $(event.target).closest(this.selectors.questionWrapper);
        const $questions = $questionsWrapper.find(this.selectors.questionField);

        if (!$questions[0]) {
            return;
        }

        const $newQuestions = $($questions[0]).clone();

        $newQuestions.find('input:not([type=hidden]), textarea:not([type=hidden])').each((index, element) => {
            $(element).val('');
        });

        //проходимся по новому контейнеру и удаляем все поля, которые не соответствую типу text
        $newQuestions.find('input:not([type=hidden])').each((index, element) => {
            $(element).attr('type="checkbox"');
            if ($(element).attr('type') !== 'text') {
                $(element).closest(this.selectors.simpleFormHolder).remove();
            }
        });

        if (!$newQuestions.find(this.selectors.simpleFormHolder).length) {
            return;
        }

        $newQuestions.appendTo($questionsWrapper.find(this.selectors.question));

        this.toggleHeightWrapper();
    }

    /**
     * Данные запроса
     * @private
     */
    private getRequestData(): JQuery.NameValuePair[]
    {
        const CLINIC_FIELD_NAME_WEBSITE = 'clinic_website'
        let data = this.$forms.eq(this.currentValue).find('form').serializeArray();
        data.push({
            name: 'type',
            value: this.currentValue.toString(),
        });

        if (this.currentValue === 1) {
            data = data.map((item) => {
                if (item.name === CLINIC_FIELD_NAME_WEBSITE) {
                    return {
                        ...item,
                        value: item.value.length ? item.value : 'Нет',
                    }
                }

                return item;
            })
        }

        return data;
    }
    /**
     * Очистка ошибок валидации
     * @private
     */
    private clearErrors()
    {
        const $currentForm = this.$forms.eq(this.currentValue);
        $currentForm.find(this.selectors.fieldError).html('');
        $currentForm.find(this.selectors.simpleFormHolder).removeClass(this.ERROR_CLASS);
    }

    /**
     * Очистка полей формы
     * @private
     */
    private clearFields()
    {
        const $currentForm = this.$forms.eq(this.currentValue);

        $currentForm.find('input:not([type=hidden]), textarea:not([type=hidden])').each((index, element) => {
            $(element).val('');
        });

        $currentForm.find('input:not([type=hidden]):checkbox, input:not([type=hidden]):radio').each((index, element) => {
            $(element).prop('checked', false);
        });

        $currentForm.find('select').each((_, element) => {
            $(element).find('option:eq(0)').prop('selected',true);
            $(element).trigger('change');
        });

        this.$checkboxAddress.closest(this.selectors.simpleFormHolder).find(`input[type="text"]`).prop('readonly', false);
        this.$holder.find('.js-main-address').off('input');
    }

    /**
     * Очистка одного поля
     * @param $field
     * @private
     */
    private clearError($field: JQuery): void
    {
        const $holderField = $field.closest(this.selectors.simpleFormHolder);
        const $error = $holderField.find(this.selectors.fieldError);

        $holderField.removeClass(this.ERROR_CLASS);
        $error.html('');
        this.toggleHeightWrapper();
    }

    /**
     * Отображение ошибок валидации
     * @param errors
     * @private
     */
    private showValidateErrors(errors: {[key: string]: Array<string>}): void
    {
        const $currentForm = this.$forms.eq(this.currentValue);
        for (let name in errors) {

            let additionalFieldName = name.split('.');

            let formFieldName = name;
            let $input = $currentForm.find('[name="' + name + '"]');
            if (additionalFieldName.length > 1 ) {
                formFieldName = additionalFieldName.length === 2 ?
                    additionalFieldName[0] + '[' + additionalFieldName[1] + ']' :
                    additionalFieldName[0] + '[' + additionalFieldName[1] + ']' + '[]';
                $input = additionalFieldName.length === 2 ?
                    $($currentForm.find(`[name="${formFieldName}"]`)) :
                    $($currentForm.find(`[name="${formFieldName}"]`)[additionalFieldName[2]]);
            }
            if (!$input.length) {
                continue;
            }

            const fieldErrors = errors[name];
            if (!fieldErrors.length) {
                continue;
            }

            let firstError = fieldErrors[0];
            const $fieldHolder = $input.closest(this.selectors.simpleFormHolder);
            $fieldHolder.addClass(this.ERROR_CLASS);
            $fieldHolder.find(this.selectors.fieldError).text(firstError);
        }

        this.toggleHeightWrapper();
    }

    /**
     * Переходим на первый шаг
     * @private
     */
    private goToFirstStep()
    {
        const $currentForm = this.$forms.eq(this.currentValue);
        const $allSteps = $currentForm.find(this.selectors.formStep);
        const $firstStep = $($allSteps[0]);

        if (!$firstStep.length) {
            return;
        }

        $allSteps.removeClass(this.ACTIVE_CLASS);
        $firstStep.addClass(this.ACTIVE_CLASS);
        this.toggleHeightWrapper();
    }

    /**
     * Выбираем ошибки только на активном шаге и показываем их
     * @private
     * @param errors
     * @param activeStep
     * @param newStep
     */
    private selectErrorsActiveStep(errors, activeStep, newStep): void
    {
        const $currentForm = this.$forms.eq(this.currentValue);
        for (let key in errors) {
            let additionalFieldName = key.split('.');
            let formFieldName = key;
            if (additionalFieldName.length > 1 ) {
                formFieldName = additionalFieldName.length === 2 ?
                    additionalFieldName[0] + '[' + additionalFieldName[1] + ']' :
                    additionalFieldName[0] + '[' + additionalFieldName[1] + ']' + '[]';
            }
            const fieldActiveStep = !!$currentForm
                .find(`[name="${formFieldName}"]`)
                .closest(`.js-form-step[data-number-step="${activeStep}"]`).length;
            if (!fieldActiveStep) {
                delete errors[key];
            }
        }
        if (Object.keys(errors).length === 0) {
            this.toggleClassStep(activeStep, newStep);
            return;
        }
        this.showValidateErrors(errors);
    }

    /**
     * Валидация формы дистрибьютеров
     * @private
     * @param activeStep
     * @param newStep
     */
    private validateDistributorForm = (activeStep, newStep): void => {
        const $currentForm = this.$forms.eq(this.currentValue);
        const urlValidate = $currentForm.find(this.selectors.feedbackForm).data('validate-url');

        $.ajax({
            url: urlValidate,
            type: 'POST',
            data: this.getRequestData(),
            success: (result: any) => {
                this.toggleClassStep(activeStep, newStep);
            },
            error: (error) => {
                if (error.status === ERROR_STATUS) {
                    this.selectErrorsActiveStep(error.responseJSON.errors, activeStep, newStep);
                } else {
                    alert('Ошибка запроса');
                }
            }
        });
    };

    /**
     * На кнопку Отправить, но еще не отправляем форму
     * @private
     */
    private preSubmitForm() {
        const $currentForm = this.$forms.eq(this.currentValue);
        const urlValidate = $currentForm.find(this.selectors.feedbackForm).data('validate-url');
        const $currentSubmitButton = $currentForm.find('button[type="submit"]');

        $currentSubmitButton.addClass(this.LOADING_CLASS)
            .prop('disabled', true);

        this.clearErrors();

        $.ajax({
            url: urlValidate,
            type: 'POST',
            data: this.getRequestData(),
            success: (result: any) => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                this.clearFields();
                this.goToFirstStep();
            },
            error: (error) => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                if (error.status === ERROR_STATUS) {
                    if (Object.keys(error.responseJSON.errors).length === 1
                        &&  typeof error.responseJSON.errors['captcha'] !== 'undefined') {
                        this.popupManager.openPopupByType(this.TYPE_CAPTCHA_POPUP, false);
                    } else {
                        this.showValidateErrors(error.responseJSON.errors);
                        this.refreshCaptcha();
                        this.cleanCaptchaField();
                    }
                } else {
                    alert('Ошибка запроса');
                }
            }
        });
    }

    /**
     * отправка формы
     * @private
     */
    private submit()
    {
        const $currentForm = this.$forms.eq(this.currentValue);
        const urlSubmit = $currentForm.find(this.selectors.feedbackForm).data('submit-url');

        const $currentSubmitButton = $currentForm.find('button[type="submit"]');

        $currentSubmitButton.addClass(this.LOADING_CLASS)
            .prop('disabled', true);

        this.clearErrors();

        $.ajax({
            url: urlSubmit,
            type: 'POST',
            data: this.getRequestData(),
            success: (result: any) => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                this.clearFields();
                this.goToFirstStep();
                this.popupManager.openPopupByType(this.TYPE_SUCCESS_POPUP, false);
            },
            error: (error) => {
                $currentSubmitButton.removeClass('loading')
                    .prop('disabled', false);
                if (error.status === ERROR_STATUS) {
                    if (Object.keys(error.responseJSON.errors).length === 1
                        &&  typeof error.responseJSON.errors['captcha'] !== 'undefined') {
                        this.popupManager.openPopupByType(this.TYPE_CAPTCHA_POPUP, false);
                    }
                    this.showValidateErrors(error.responseJSON.errors);
                    this.refreshCaptcha();
                    this.cleanCaptchaField();
                } else {
                    alert('Ошибка запроса');
                }
            }
        });
    }

    /**
     * Рандомный символ в конец ссылки на изображение капчи
     *
     * @param characterBesides
     * @param counter
     * @private
     */
    private randomCharacter(characterBesides: string, counter:number = 0)
    {
        const alphabet = "abcdefghijklmnopqrstuvwxyz1234567890"

        const randomCharacter = alphabet[Math.floor(Math.random() * alphabet.length)]

        if (characterBesides == randomCharacter && counter < 1000) {
            return this.randomCharacter(randomCharacter, counter++);
        }

        return randomCharacter;
    }

    /**
     * Обновить капчу
     * @private
     */
    private refreshCaptcha(): void
    {
        const captchaImageSrc = this.$forms.find(this.selectors.captchaImage).find('img');

        const src = captchaImageSrc.attr('src');

        const randomCharacter = this.randomCharacter(src.slice(-1));

        captchaImageSrc.attr('src', src.slice(0,-1) + randomCharacter);
    }

    /**
     * Очистить инпут капчи
     * @private
     */
    private cleanCaptchaField(): void
    {
        this.$forms.find(this.selectors.captchaInput).val(null);
    }
}
